import { Button, type ButtonProps } from "@mantine/core";
import { IconPhoneCall } from "@tabler/icons-react";
import { IvrInstructionsModal } from "./ivr-instructions-modal";
import { useState } from "react";

export function IvrInstructionsButton(props?: ButtonProps) {
	const [activeModal, setActiveModal] = useState<"ivr" | null>(null);
	const closeModal = () => setActiveModal(null);
	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		setActiveModal("ivr");
	};

	return (
		<>
			<Button
				variant="default"
				size="xs"
				justify="center"
				leftSection={<IconPhoneCall size={16} />}
				{...props}
				//added to bottom to prevent onclick overrides if passed in by props
				onClick={handleClick}
			>
				Call to check in or out
			</Button>
			<IvrInstructionsModal
				opened={activeModal === "ivr"}
				onClose={closeModal}
			/>
		</>
	);
}
